import { render } from "./TryOnUsageStats.vue?vue&type=template&id=0130e938&scoped=true"
import script from "./TryOnUsageStats.vue?vue&type=script&lang=js"
export * from "./TryOnUsageStats.vue?vue&type=script&lang=js"

import "./TryOnUsageStats.vue?vue&type=style&index=0&id=0130e938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0130e938"]])

export default __exports__